import { render, staticRenderFns } from "./FacilityLabel.vue?vue&type=template&id=e402be2c&scoped=true&"
import script from "./FacilityLabel.vue?vue&type=script&lang=ts&"
export * from "./FacilityLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e402be2c",
  null
  
)

export default component.exports